import apiClient from '@/api/apiClient';
import { handleError, getAuthData, prepareModel, validateId } from '../../utils/storeHelpers';

export default {
  namespaced: true,
  state: {
    schema: {},
    dataCrud: [],
    checkboxNone: 0,
    isNewRecord: true,
    status: '',
  },

  getters: {
    schema: (state) => state.schema,
    dataCrud: (state) => state.dataCrud,
    checkboxNone: (state) => state.checkboxNone,
    isNewRecord: (state) => state.isNewRecord,
    status: (state) => state.status,
  },

  mutations: {
    SET_SCHEMA(state, schema) {
      state.schema = schema;
    },
    SET_RECORDS(state, { recordsData }) {
      state.dataCrud = Array.isArray(recordsData?.dataCrud) ? recordsData.dataCrud : [];
      state.checkboxNone = recordsData?.checkboxNone;
      state.isNewRecord = Boolean(recordsData?.isNewRecord);
    },
    SET_STATUS(state, status) {
      state.status = status;
    },
  },

  actions: {
    async fetchSchema({ commit }) {
      try {
        commit('SET_STATUS', 'loading');
        const responses = await Promise.all([
          apiClient.caxAALxAcademicSchema(),
          apiClient.catCareers(),
          apiClient.catEduInstitutions(),
          apiClient.catInstitutionType(),
        ]);
        const [schemaRes, catCareers, catEduInstitutions, catInstitutionType] =
          responses.map((res) => res?.data ?? {});

        let id1 = 'G';
        const resCat4 = await apiClient.catLevelDescription(id1);
        const catLevelDescriptionG = resCat4.data.data;

        let id2 = 'H';
        const resCat5 = await apiClient.catLevelDescription(id2);
        const catLevelDescriptionH = resCat5.data.data;

        if (!schemaRes.formCrud) throw new Error('Estructura de schema inválida.');

        const schema = structuredClone(schemaRes);
        schema.formCrud.careers_code.items = catCareers.data ?? [];
        schema.formCrud.edu_institution_code.items = catEduInstitutions.data ?? [];
        schema.formCrud.career_institution_type_code.items = catInstitutionType.data ?? [];
        schema.formCrud.career_adaptability_level_description_id.items = catLevelDescriptionG;
        schema.formCrud.career_satisfaction_level_description_id.items = catLevelDescriptionH;
        schema.formCrud.career_stress_level_description_id.items = catLevelDescriptionH;
        schema.formCrud.career_relation_peers_level_description_id.items = catLevelDescriptionG;
        schema.formCrud.career_relation_authority_level_description_id.items = catLevelDescriptionG;
        commit('SET_SCHEMA', schema);
      } catch (error) {
        handleError(error, commit);
      }
    },

    async fetchRecords({ commit, rootState }) {
      try {
        const { clinicalHistories_id, institutions_profes_id } = getAuthData(rootState);
        const res = await apiClient.modelCAxAALxAcademic(clinicalHistories_id, institutions_profes_id);
        const recordsData = res?.data?.data ?? []; 
        commit('SET_RECORDS', { recordsData });
        commit('SET_STATUS', 'loaded');
      } catch (error) {
        handleError(error, commit);
      }
    },

    async createRecord({ commit, rootState }, { model }) {
      try {
        commit('SET_STATUS', 'create');
        const preparedModel = prepareModel(rootState, model);
        await apiClient.createCAxAALxAcademic(preparedModel);
        commit('SET_STATUS', 'success');
      } catch (error) {
        handleError(error, commit);
      }
    },

    async updateRecord({ commit, rootState }, { model }) {
      try {
        commit('SET_STATUS', 'update');
        const { clinicalHistories_id } = getAuthData(rootState);
        const preparedModel = prepareModel(rootState, model);
        await apiClient.updateCAxAALxAcademic(clinicalHistories_id, preparedModel);
        commit('SET_STATUS', 'success');
      } catch (error) {
        handleError(error, commit);
      }
    },

    async removeRecord({ commit, rootState }, { id }) {
      try {
        commit('SET_STATUS', 'remove');
        const { clinicalHistories_id, institutions_profes_id } = getAuthData(rootState);
        validateId(id);
        await apiClient.deleteCAxAALxAcademic(id, clinicalHistories_id, institutions_profes_id);
        commit('SET_STATUS', 'success');
      } catch (error) {
        handleError(error, commit);
      }
    },
  },
};
